const MAX_NICKNAMES = 5
const MAX_NICKNAME_LENGTH = 40

/** The nicknames typed into the comma field, tidied the way the listing API accepts them. */
export function splitNicknames(text: string | undefined): string[] {
  const nicknames = new Map<string, string>()
  for (const part of (text ?? '').split(',')) {
    const nickname = part.replace(/\s+/g, ' ').trim().slice(0, MAX_NICKNAME_LENGTH).trim()
    if (nickname && !nicknames.has(nickname.toLowerCase())) {
      nicknames.set(nickname.toLowerCase(), nickname)
    }
  }
  return [...nicknames.values()].slice(0, MAX_NICKNAMES)
}
